module.exports = __webpack_public_path__ + "static/media/moving-into-extra-space-storage_2x.27d80eb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/moving-into-extra-space-storage_2x.png
// module id = 1190
// module chunks = 27